import { Compiler, getModuleFactory, Injector, NgModule, NgModuleFactory } from '@angular/core';
import { Routes, RouterModule, LoadChildren } from '@angular/router';
import { values } from 'lodash';
//import { LazyLoaderService } from './lazy-loader.service';
//import { LoadLayzModuleService } from './load-layz-module.service';
import { MasterlayoutComponent } from './masterlayout.component';
import { AuthGuard } from './Pages/core/authentication/auth.guard';
import { injectionModuleService } from './Pages/shared/Services/injectionModuleService.service';
// import {AuthenticationModule} from './Pages/authentication/authentication.module';
// export function getAuthenticationModule() {
//  return AuthenticationModule;
// }

// import {HomeModule} from './Pages/home/home.module';
// export function getHomeModule() {
//  return HomeModule;
// }

// import {UsersModule} from './Pages/users/users.module';
// export function getUsersModule() {
//  return UsersModule;
// }

// import {LocalizationsModule} from './Pages/localizations/localizations.module';
// export function getLocalizationsModule() {
//  return LocalizationsModule;
// }

// import { RolesModule } from './Pages/roles/roles.module';
// export function getRolesModule() {
//  return RolesModule;
// }

// import { NotificationsModule } from './Pages/notifications/notifications.module';
// export function getNotificationsModule() {
//  return NotificationsModule;
// }

// import { LookupsModule } from './Pages/lookups/lookups.module';
// export function getLookupsModule() {
//  return LookupsModule;
// }
// import { DepartmentsModule } from './Pages/departments/departments.module';
// export function getDepartmentsModule() {
//  return DepartmentsModule;
// }
// import { SectorsModule } from './Pages/sectors/sectors.module';
// export function getSectorsModule() {
//  return SectorsModule;
// }
// import { ConfigurationsModule } from './Pages/configurations/configurations.module';
// export function getConfigurationsModule() {
//  return ConfigurationsModule;
// }

// import { ImpersonationRulesModule } from './Pages/impersonation-rules/impersonation-rules.module';
// export function getImpersonationRulesModule() {
//  return ImpersonationRulesModule;
// }

// import { JobsModule } from './Pages/jobs/jobs.module';
// export function getJobsModule() {
//  return JobsModule;
// }

// import { LicenseModule } from './Pages/license/license.module';
// export function getLicenseModule() {
//  return LicenseModule;
// }

// import { WorkflowsModule } from './Pages/workflows/workflows.module';
// export function getWorkflowsModule() {
//  return WorkflowsModule;
// }

// import { PublicHolidaysModule } from './Pages/publicHolidays/public-holidays.module';
// export function getPublicHolidaysModule() {
//   return PublicHolidaysModule;
// }
// import { HelpCenterModule } from './Pages/helpCenter/help-center.module';
// export function getHelpCenterModule() {
//   return HelpCenterModule;
// }
// import { LogsModule } from './Pages/logs/logs.module';
// export function getLogsModule() {
//   return LogsModule;
// }
// import { ProvidersModule } from './Pages/providers/providers.module';
// export function getProvidersModule() {
//   return ProvidersModule;
// }
 export let AppInjector: Injector;

// export let routes: Routes =
           
// [
//    {
//      path: '', redirectTo: 'Home', pathMatch: 'full'
//    },
//    {
//      path: 'authentication', loadChildren:getAuthenticationModule
//    },

//    {
//      path: 'Home', loadChildren: getHomeModule
//    },
//    {
//      path: 'Users', loadChildren:getUsersModule
//    }
//    ,
//    {
//      path: 'Localization', loadChildren: getLocalizationsModule
//    }
//    ,
//    {
//      path: 'Roles', loadChildren: getRolesModule
//    }
//    ,
//    {
//      path: 'Notifications', loadChildren: getNotificationsModule
//    }
//    ,
//    {
//      path: 'Lookups', loadChildren: getLookupsModule
//    }
//    ,
//    {
//      path: 'Departments', loadChildren: getDepartmentsModule
//    }
//    ,
//    {
//      path: 'Sectors', loadChildren: getSectorsModule
//    }
//    ,
//    {
//      path: 'Configurations', loadChildren: getConfigurationsModule
//    }
//    ,
//    {
//      path: 'ImpersonationRules', loadChildren: getImpersonationRulesModule
//    }
//    ,
//    {
//      path: 'Jobs', loadChildren: getJobsModule
//    }

//    ,
//    {
//      path: 'License', loadChildren: getLicenseModule
//    }
//    ,
//    {
//      path: 'Workflows', loadChildren: getWorkflowsModule
//    }
//      ,
//      {
//        path: 'PublicHolidays', loadChildren: getPublicHolidaysModule
//      } ,
//      {
//        path: 'HelpCenter', loadChildren: getHelpCenterModule
//      },
//      {
//        path: 'Logs', loadChildren: getLogsModule
//      },
//      {
//        path: 'Providers', loadChildren: getProvidersModule
//      } ,
    
  
// ]
// export let  getrouts=()=> {
//   for (let index = 0; index < injectionModuleService.InjectedModules.length; index++) {
//     const InjectedModule = injectionModuleService.InjectedModules[index];
//     routes.push({path:InjectedModule.routeName,loadChildren:InjectedModule.module})
//   }
//   return routes;
// }

// @dynamic

@NgModule({

  imports: [
RouterModule.forChild(
      [
        {
          path: '',
          component: MasterlayoutComponent,
          canActivate:[AuthGuard],
          children: injectionModuleService.routesArray
        }
      ]
    
    ),

  ],
  exports: [RouterModule],
  providers:[]



})
//@dynamic
export class MasterlayoutRoutingModule {
  constructor(private injector: Injector) 
  {
    AppInjector = this.injector;
  }
  static components = [MasterlayoutComponent];
}

